<template>
    <Dialog :open="open" title="Select Columns" @close="$emit('close')" @enter="save">

        <v-row>
            <v-col class="d-flex justify-center">
                <div class="d-flex justify-center flex-column">
                    <div v-for="(column, index) in columns" :key="index" class="d-flex">
                        <v-switch
                                v-if="column.text"
                                v-model="column.visible"
                                :label="column.text"
                                color="accent"
                                inset
                        ></v-switch>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="text-right">
                <v-btn
                        ref="save"
                        :disabled="!hasChanges"
                        class=" py-6 accentText--text shadow-inverse"
                        color="accent"
                        depressed
                        @click="save">
                    {{ $t('save') }}
                </v-btn>
            </v-col>
        </v-row>
    </Dialog>
</template>

<script>
import Dialog from "@/components/reusable/Dialog/Dialog";
import {isEqual} from "@/helper/helper";

export default {
  name: "ColumnSelector",
  components: {Dialog},
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    value: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      columns: [...this.value.map(column => ({...column}))],
      hasChanges: false,
    };
  },
  watch: {
    value: {
      handler() {
        this.columns = [...this.value.map(column => ({...column}))];
      },
      deep: true
    },
    columns: {
      handler() {
        this.hasChanges = !isEqual(this.value, this.columns);
      },
      deep: true
    }
  },
  methods: {
    save() {
      this.$emit('input', this.columns);
      this.$emit('close');
    }
  }
};
</script>

<style scoped>

</style>